//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getWuYeWorkers, getWeiBaoWorkers, getWuYeUser, getWeiBaoUser } from '../../../api/workOrder';

export default {
    name: 'select-repairer-user-view',
    props: {
        type: String,
        organizationId: Number,
        selected: Function,
        value: Boolean
    },
    data() {
        return {
            users: [],
            title: '',
            selectedUserId: 0
        };
    },
    methods: {
        visibleChange(value) {
            if (!value) {
                // (this.$refs.userForm as any).resetFields();
                this.$emit('input', value);
            }
        },
        cancel() {
            // (this.$refs.userForm as any).resetFields();
            this.$emit('input', false);
        },
        getWuYeUser() {
            getWuYeUser(this.organizationId).then(res => {
                this.users = [];
                this.users.push(...res.data.result);
                this.init();
            });
        },
        getWeiBaoUser() {
            getWeiBaoUser(this.organizationId).then(res => {
                this.users = [];
                this.users.push(...res.data.result);
                this.init();
            });
        },
        getWuYeWorkers() {
            getWuYeWorkers(this.organizationId).then(res => {
                this.users = [];
                this.users.push(...res.data.result);
                this.init();
            });
        },
        getWeiBaoWorkers() {
            getWeiBaoWorkers(this.organizationId).then(res => {
                this.users = [];
                this.users.push(...res.data.result);
                this.init();
            });
        },
        init() {
            if (this.users.length === 1) {
                this.selectedUserId = this.users[0].id;
            }
        },
        onSelected() {
            if (this.selectedUserId === 0) {
                this.$Message.error('请选择人员');
                return;
            }
            let user = this.users.find(z => z.id === this.selectedUserId);
            if (user === undefined) {
                return;
            }
            user.businessType = this.type;
            this.selected(user);
            this.$emit('input', false);
        }
    },
    created() {
        if (this.type === 'user') {
            this.getWuYeUser();
            this.title = '维修负责人';
        } else if (this.type === 'workerUser') {
            this.getWuYeWorkers();
            this.title = '物业维修工程师';
        } else if (this.type === 'weiBaoUser') {
            this.getWeiBaoUser();
            this.title = '维保负责人';
        } else if (this.type === 'weiBaoWorkerUser') {
            this.getWeiBaoWorkers();
            this.title = '维保工程师';
        } else {

        }
    }
};
